import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useT } from "@/i18n";

const STORAGE_KEY = "fundinorevia_cookie_consent_v1";

function updateConsent(granted) {
  const state = granted ? "granted" : "denied";
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      ad_storage: state,
      ad_user_data: state,
      ad_personalization: state,
      analytics_storage: state,
    });
  }
}

const CookieBanner = () => {
  const { lang, t } = useT();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (!stored) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const decide = (accept) => {
    try {
      window.localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ accepted: accept, ts: Date.now() })
      );
    } catch {
      // ignore storage errors
    }
    updateConsent(accept);
    setVisible(false);
  };

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-live="polite"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-slate-200 bg-white shadow-2xl"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-5 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:gap-8 lg:px-8">
        <div className="max-w-3xl">
          <h2 className="font-serif text-base font-semibold text-slate-900">
            {t("cookie_banner.title")}
          </h2>
          <p className="mt-1 text-sm leading-relaxed text-slate-600">
            {t("cookie_banner.body")}{" "}
            <Link
              to={`/${lang}/cookies`}
              data-testid="cookie-banner-policy-link"
              className="font-medium text-[#0B2545] underline underline-offset-2 hover:text-[#133B6A]"
            >
              {t("cookie_banner.policy")}
            </Link>
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <button
            type="button"
            data-testid="cookie-banner-reject"
            onClick={() => decide(false)}
            className="rounded-md border border-slate-300 px-4 py-2 text-sm font-semibold text-slate-700 hover:border-slate-400"
          >
            {t("cookie_banner.reject")}
          </button>
          <button
            type="button"
            data-testid="cookie-banner-accept"
            onClick={() => decide(true)}
            className="rounded-md bg-[#0D9488] px-4 py-2 text-sm font-semibold text-white hover:bg-[#0F766E]"
          >
            {t("cookie_banner.accept")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
